var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.0898,
    y: 30.249,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 30.249,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2539,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1289,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2109,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 56.293,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0898,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 25.207,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1641,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1211,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 10.082,
    y: 35.291,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1211,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 10.082,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 5.03906,
    y: 40.332,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 10.082,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 5.03906,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    y: 30.249,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0039,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9219,
    y: 25.207,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9219,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9219,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 5.87891,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0039,
    y: 5.04102,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0039,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 26.043,
    y: 10.083,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0039,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 26.043,
    y: 15.124,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 26.043,
    y: 20.166,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0898,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 25.207,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 25.207,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1641,
    y: 45.374,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1641,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1641,
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1211,
    y: 50.415,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 5.03906,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1211,
    y: 55.4561,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1211,
    y: 60.498,
    width: 5.04149,
    height: 5.04149,
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuit);
export default __webpack_public_path__ + "static/media/cuit.90f0e5093b7dce234c467c96d66da78e.svg";
export { ForwardRef as ReactComponent };